<template>
  <el-row>
    <el-col style="padding-top: 6px;" :span="4">
      <el-row class="title-bar">
        <div class="title-h3 mr-r15">관리 그룹</div>
      </el-row>
      <div>
        <w-physical-tree class="mr-r20" ref="sideTree" managetype-id="NMS" @clickNode="onClickNode"></w-physical-tree>
      </div>
    </el-col>
    <el-col :span="20">
      <w-obj-list-table :selected-node="selectedNode"></w-obj-list-table>
    </el-col>
  </el-row>
</template>

<script>
import WPhysicalTree from '@/components/tree/DynamicPhysicalTree';
import WObjListTable from './components/ObjListTable';

export default {
  name: 'WObjCollectSetting',
  components: {
    WObjListTable,
    WPhysicalTree,
  },
  data() {
    return {
      selectedNode: {},
      nodeData: {},
    };
  },
  methods: {
    onClickNode(data) {
      this.selectedNode = data;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/SnmpTrap/ObjCollectSetting.vue